/* eslint-disable no-param-reassign,max-len */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  FetchGroupFilterPayload, GetGroupResponse, GroupsState, IGroup,
} from '../interface';

export const initialState:GroupsState = {
  loading: false,
  groups: [],
  total: 0,
};

export const groupsSlice = createSlice({
  name: 'feature/groups/list',
  initialState,
  reducers: {
    getGroups(state: GroupsState, action: PayloadAction<FetchGroupFilterPayload>) {
      state.loading = true;
    },
    getGroupsSucceeded(state: GroupsState, _action: PayloadAction<GetGroupResponse>) {
      const { result, total } = _action.payload;
      state.loading = false;
      state.groups = result;
      state.total = total;
    },
    getGroupsFailed(state: GroupsState) {
      state.loading = false;
    },
    hideGroupItem(state:GroupsState, action: PayloadAction<any>) {
      state.loading = true;
    },
    hideGroupItemSucceeded(state:GroupsState, _action:PayloadAction<IGroup>) {
      state.loading = false;
      const groupItem = _action.payload;
      const updatedData = state.groups.filter((x) => (x._id !== groupItem._id));
      state.groups = updatedData;
    },
    updateGroupItemFailed(state: GroupsState) {
      state.loading = false;
    },
  },
});

export const { actions: groupsAction } = groupsSlice;
